import { IResponsePagination } from '@/types/common';
import { IAdminFamilyRow, IListFamiliesRequest } from '@/types/response';
import axiosClient from '../axiosClient';
import { ENDPOINT } from '../endpoint';

class FamilyAdmin {
  /** 家族一覧（アクティブ度・課金・企業コード付き） */
  listFamilies = (
    params: IListFamiliesRequest,
  ): Promise<IResponsePagination<IAdminFamilyRow>> =>
    axiosClient.get(ENDPOINT.FAMILY.LIST, { params });
}

export const FamilyAdminService = new FamilyAdmin();
